import { Flex, Text } from "@engaging-tech/components"
import React, { useEffect, useState } from "react"

import AutoCarousel from "../../../components/auto-carousal"
import { MULTI_CARD_CAROUSEL_TYPE } from "../../../components/auto-carousal/autoCarousel.styled"
import getWhwSponsors from "../../../services/sponsors"

const SponsorsCarouselRow = ({ label = "Global Partners", slides = [], options = {} }) => {
  return (
    <Flex flexDirection="column" width={1 / 1}>
      <Flex justifyContent="center" alignItems="center">
        <Text textAlign="center" fontSize={14} fontWeight={400} mb={3} mt={3} width={1 / 1} lineHeight="20px">
          {label}
        </Text>
      </Flex>
      <AutoCarousel type={MULTI_CARD_CAROUSEL_TYPE} slides={slides} options={options} />
    </Flex>
  )
}

const SponsorsCarousel = () => {
  const [allSponsors, setAllSponsors] = useState()
  useEffect(() => {
    async function loadSponsors() {
      const res = await getWhwSponsors()
      setAllSponsors(res)
    }
    loadSponsors()
  }, [setAllSponsors])
  if (allSponsors?.isLoading) return null

  return (
    <Flex flexDirection="column" width={[1 / 1]}>
      {allSponsors?.data?.sponsors?.globalPartners?.data?.length ? (
        <SponsorsCarouselRow slides={allSponsors?.data?.sponsors?.globalPartners?.data || []} />
      ) : null}
      {allSponsors?.data?.sponsors?.partners?.data?.length ? (
        <SponsorsCarouselRow label="Partners" slides={allSponsors?.data?.sponsors?.partners?.data || []} />
      ) : null}
      {allSponsors?.data?.sponsors?.sponsors?.data?.length ? (
        <SponsorsCarouselRow label="Sponsors" slides={allSponsors?.data?.sponsors?.sponsors?.data || []} />
      ) : null}
      {allSponsors?.data?.sponsors?.mediaSponsors?.data?.length ? (
        <SponsorsCarouselRow
          label="Media Sponsors"
          slides={allSponsors?.data?.sponsors?.mediaSponsors?.data || []}
        />
      ) : null}
    </Flex>
  )
}

export default SponsorsCarousel
